export const displayCountryDesc = (country: string, selectedOption: string) => {
  switch (country) {
    case "Germany":
      return selectedOption;
    case "Italy":
      return "Italian Equities";
    case "Japan":
      return "Japanese Payment Breakdown";
    case "South Korea":
      return "South Korean Depository Receipts";
    case "Spain":
      return "Spanish Securities - Standard refund";
    case "Singapore":
      return "Singaporean Equities";
  }
  return country;
};

export const getSecurityType = (country: string, selectedOption: string) => {
  switch (country) {
    case "Germany":
      return selectedOption.substring(7);
    case "Italy":
      return "Equities";
    case "Japan":
      return "Payment Breakdown";
    case "South Korea":
      return "Depository Receipts";
    case "Spain":
      return "Standard refund";
    case "Singapore":
      return "Equities";
  }
  return country;
};

export const convertStringToDate = (stringDate: string | undefined) => {
  if (stringDate && stringDate.length > 0) {
    return new Date(
      stringDate.substring(3, 5) +
        "/" +
        stringDate.substring(0, 2) +
        "/" +
        stringDate.substring(6)
    );
  }
  return;
};

export const allowedFileExtensions = (country: string) => {
  switch (country) {
    case "Germany":
      return ".csv";
    case "Italy":
      return ".xls, .xlsx";
    case "Japan":
      return ".csv, .xls, .xlsx";
    case "South Korea":
      return ".xls, .xlsx";
    case "Spain":
      return ".csv, .xls, .xlsx";
    case "Singapore":
      return ".csv, .xls, .xlsx";
  }
};
